import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { paymentRulesReducers } from './reducers/payment-rules.reducer';
import { PaymentRulesEffects } from './effects/payment-rules.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('paymentRules', paymentRulesReducers),
    EffectsModule.forFeature([PaymentRulesEffects]),
  ],
})
export class PaymentRulesStoreModule {}
